import callApi from "./callApi"

const putPdpa = (body) => {
    return new Promise(async (resolve, reject) => {
        const method = "put"
        const url = `${process.env.REACT_APP_API}/api/shade/auths/pdpa`
        const headers = null
        try {
            const request = await callApi(method, url, body, headers)
            resolve(request)
        } catch (error) {
            reject(error)
        }
    })
}

export default putPdpa

// const checkWaitingForPaymentBooking = (data) => {
//     return new Promise(async (resolve, reject) => {
//         const url = `${process.env.REACT_APP_API_COVID19}/api/map-routes/check/booking`
//         const method = 'post'
//         const body = data
//         try {
//             const response = await callApi(method, url, body, null)
//             resolve(response)
//         } catch (error) {
//             reject(error)
//         }
//     })
// }

// export default checkWaitingForPaymentBooking